export const TEMP_DATASOURCE_ID = "temp-id-0";
export const DATASOURCE_NAME_DEFAULT_PREFIX = "Untitled Datasource ";
